function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { useRefCallback } from '@bydesign-ui/hooks';
import { classnames } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
import { Link } from '../../../components/link';
export function DatePreset(props) {
  var presets = props.presets,
      className = props.className,
      onPresetItemClick = props.onPresetItemClick,
      onPresetItemMouseEnter = props.onPresetItemMouseEnter,
      onPresetItemMouseLeave = props.onPresetItemMouseLeave,
      extra = _objectWithoutProperties(props, ["presets", "className", "onPresetItemClick", "onPresetItemMouseEnter", "onPresetItemMouseLeave"]);

  var cls = classnames(usePrefixCls('date-panel-preset'), className);
  var itemCls = usePrefixCls('date-panel-preset-item');
  var onPresetItemClickCallback = useRefCallback(onPresetItemClick);
  var onPresetItemMouseEnterCallback = useRefCallback(onPresetItemMouseEnter);
  var onPresetItemMouseLeaveCallback = useRefCallback(onPresetItemMouseLeave);

  if (!presets.length) {
    return null;
  }

  return React.createElement("div", Object.assign({}, extra, {
    className: cls
  }), presets.map(function (item) {
    return React.createElement("div", {
      className: itemCls,
      key: item.key
    }, React.createElement(Link, {
      size: 'sm',
      onClick: function onClick() {
        return onPresetItemClickCallback(item);
      },
      onMouseEnter: function onMouseEnter() {
        return onPresetItemMouseEnterCallback(item);
      },
      onMouseLeave: function onMouseLeave() {
        return onPresetItemMouseLeaveCallback(item);
      }
    }, item.label));
  }));
}